<div class="common-style manage-maintenance-dialog position-relative">
  <div class="panel-header d-flex align-items-center justify-content-between">
    <div class="panel-header-spacer"></div>
    <div class="panel-title-block flex-grow-1 text-center">
      <div class="panel-title-row justify-content-center">
        <h6 class="panel-title mb-0">
          {{ maintenanceData?.title }}
        </h6>
        <div class="badge-container ms-2">
          <div class="maintenance-status-pill" [ngClass]="getStatusClass(maintenanceData?.status)">
            <span class="status-dot"></span>
            <span class="pill-text">{{ getMaintenanceStatusLabel(maintenanceData?.status) | titlecase }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-actions d-flex align-items-center">
      <button type="button" mat-icon-button class="panel-close-btn" (click)="onCancel()" matTooltip="Close">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
  </div>

  @if (isViewLoading) {
    <div class="dialog-body common-style mt-2 mb-2 flex-grow-1">
      <div class="drawer-skeleton">
        <div class="skeleton-line w-30"></div>
        <div class="skeleton-box"></div>

        <div class="skeleton-line w-35"></div>
        <div class="skeleton-box tall"></div>

        <div class="skeleton-row">
          <div class="skeleton-box half"></div>
          <div class="skeleton-box half"></div>
        </div>
      </div>
    </div>
  } @else {
    <div class="dialog-body form common-style mt-2 mb-2 flex-grow-1">
      <div class="maintenance-manage-container pt-0">


        <!-- Refined Layout: Status -> Description -> Scheduled Window -->
        @if (!isHistoricalMaintenance) {
          <form id="manageMaintenanceForm" class="maintenance-update-form" [formGroup]="updateForm"
            (ngSubmit)="onSaveMainStatus()">
            <div class="col-sm-12 mb-4">
              <span class="title-name">Status <span class="mandatory-star">*</span></span>
              <div class="error-input-wrapper">
                <app-custom-select label="Status" [items]="maintenanceStatusOptions" formControlName="status"
                  bindLabel="label" bindValue="value">
                </app-custom-select>
                @if (updateForm.get('status')?.invalid && updateForm.get('status')?.touched) {
                  <mat-error>
                    Status is required
                  </mat-error>
                }
              </div>
            </div>

            <div class="col-sm-12 mb-4">
              <span class="title-name">Description <span class="mandatory-star">*</span>
              @if (descriptionLength !== null) {
                <span class="ms-3">({{descriptionLength}} Char)</span>
              }
            </span>
            <div class="error-input-wrapper">
              <quill-editor class="d-flex flex-column messagefield" appStatusDrawerQuillKeyboard
                [placeholder]="'Describe the maintenance window details...'"
                [modules]="messageEditorModules"
                formControlName="description" theme="snow" (onContentChanged)="onContentChanged($event)">
              </quill-editor>
              @if (updateForm.get('description')?.hasError('required') && updateForm.get('description')?.touched) {
                <mat-error>
                  Description is required
                </mat-error>
              }
              @if ((updateForm.get('description')?.hasError('pattern') || updateForm.get('description')?.hasError('invalidDescription')) && updateForm.get('description')?.touched) {
                <mat-error>
                  Description is invalid
                </mat-error>
              }
              @if (updateForm.get('description')?.hasError('maxTextLength') && updateForm.get('description')?.touched) {
                <mat-error>
                  Description must be 5000 characters or fewer
                </mat-error>
              }
            </div>
          </div>

          @if (showDateEditing) {
            <div class="row">
              <div class="col-sm-6 mb-3">
                <app-date-time-picker label="Scheduled Start" formControlName="startDate" [required]="true"
                  [minDate]="minDate" [minDateTime]="minDateTime"
                  [errorMsg]="getStartDateError()">
                </app-date-time-picker>
              </div>
              <div class="col-sm-6 mb-3">
                <app-date-time-picker label="Scheduled End" formControlName="endDate" [required]="true"
                  [minDate]="minDate" [minDateTime]="minDateTime"
                  [errorMsg]="getEndDateError()" parentErrorKey="dateRangeInvalid">
                </app-date-time-picker>
              </div>
              @if (timezoneNoteLabel) {
                <div class="col-sm-12 mb-3">
                  <div class="timezone-shared-note" role="note">
                    Time Zone: {{ timezoneNoteLabel }}
                  </div>
                </div>
              }
            </div>
          }
        </form>
      } @else {
        <div class="maintenance-view-mode pb-2">
          <div class="mb-4 mt-2">
            <div class="view-label mb-2">DESCRIPTION</div>
            <div class="view-content" [innerHTML]="sanitizeHtmlContent(maintenanceData?.description) | statusPageRichText"></div>
          </div>
          <div>
            <div class="view-label mb-2">SCHEDULED WINDOW</div>
            <div class="view-content">
              {{ formatDateInPickerTz(maintenanceData?.startDate) }} &ndash; {{ formatDateInPickerTz(maintenanceData?.endDate) }} {{ timezoneAbbrev }}
            </div>
          </div>
        </div>
      }
    </div>

  </div>
}

<!-- Pinned Footer Actions at the Bottom -->
<div class="modal-action p-4">
  @if (!isHistoricalMaintenance) {
    <div class="footer-primary-actions">
      <button type="button" class="bt-border" mat-raised-button (click)="onCancel()" [disabled]="isSaving || isViewLoading">Close</button>
      @if (canCancelMaintenance) {
        <button type="button" class="bt-border" mat-raised-button (click)="onCancelMaintenance()" [disabled]="isSaving || isViewLoading">Cancel Maintenance</button>
      }
      <button type="submit" class="bt-background" mat-raised-button form="manageMaintenanceForm"
      [disabled]="isViewLoading || updateForm?.invalid || isSaving">Save Changes</button>
    </div>
    <div class="mark-completed-container">
      <button type="button" class="btn-mark-completed" mat-raised-button (click)="onMarkAsCompleted()" [disabled]="isSaving || isViewLoading">
        <mat-icon class="me-2">check_circle_outline</mat-icon>
        Mark as Completed
      </button>
    </div>
  } @else {
    <button type="button" class="bt-border" mat-raised-button (click)="onCancel()">Close</button>
  }
</div>

<!-- Spinner Overlay -->
@if (isSaving) {
  <div class="drawer-spinner-overlay">
    <mat-spinner diameter="30"></mat-spinner>
  </div>
}
</div>
